module.exports = __webpack_public_path__ + "static/media/3.79b98d9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/detail/3.png
// module id = 678
// module chunks = 0